module.exports = __webpack_public_path__ + "media/images/User-avatar-7534dfed283eb0f35090c176b4ce2a87.png";